import React from 'react';

// import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';

type Company = {
  _id: string;
  name: string;
  logo: string;
  note: string;
  employeeRange: string;
  fundingRange: string;
  location: string;
  foundationYear: string;
  websiteUrl: string;
  jobBoardUrl: string;
  scriptName: string;
  scriptId: string;
};

type Props = {
  onClose: () => void;
  open: boolean;
  company: Company;
  onShowAllJobsClick: () => void;
};

type State = {
  disabled: boolean;
  showCompanyModal: boolean;
};

class CompanyModal extends React.Component<Props, State> {
  public state = {
    disabled: false,
    showCompanyModal: false,
  };

  public render() {
    // get data
    const { open, company } = this.props;

    if (!company) {
      return null;
    }

    return (
      <>
        <Dialog
          onClose={this.handleClose}
          aria-labelledby="company-modal-for-job-dialog-title"
          open={open}
          fullWidth
        >
          <DialogTitle id="company-modal-for-job-dialog-title" style={{ background: '#dce7f1' }}>
            {company.name}
          </DialogTitle>
          <IconButton
            onClick={this.handleClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
          <DialogContent style={{ background: '#dce7f1' }}>
            <a href={company.websiteUrl} target="_blank" rel="noopener noreferrer">
              {company.websiteUrl}
            </a>
            <p />
            About:
            <li>
              Location: <b>{company.location}</b>
            </li>
            <li>
              Size: <b>{company.employeeRange}</b>
            </li>
            <li>
              Funding: <b>{company.fundingRange}</b>
            </li>
            <li>
              Founded: <b>{company.foundationYear}</b>
            </li>
            <p />
            <div style={{ textAlign: 'right' }}>
              {company.scriptName === 'script-3-rest' ? null : (
                <a onClick={this.onShowAllJobsClick} style={{ cursor: 'pointer' }}>
                  Show all jobs
                </a>
              )}
            </div>
          </DialogContent>
        </Dialog>
      </>
    );
  }

  private handleClose = () => {
    this.setState({ disabled: false, showCompanyModal: false });
    this.props.onClose();
  };

  private onShowAllJobsClick = () => {
    this.props.onShowAllJobsClick();
  };
}

export default CompanyModal;
